import { ROUTES } from './constants.js';

export function normalizeRoute(value) {
  if (!value) {
    return '';
  }

  let route = String(value).trim();
  if (!route) {
    return '';
  }

  const hashIndex = route.indexOf('#');
  if (hashIndex !== -1) {
    route = route.slice(hashIndex + 1);
  }

  const queryIndex = route.indexOf('?');
  if (queryIndex !== -1) {
    const params = new URLSearchParams(route.slice(queryIndex + 1));
    const screen = params.get('screen');
    route = screen || route.slice(0, queryIndex);
  }

  if (route.indexOf('screen=') === 0) {
    route = route.slice(7);
  }

  route = route.replace(/^\/+/, '').replace(/\.html$/i, '');

  if (route === 'index') {
    route = 'cover';
  }

  return ROUTES.indexOf(route) === -1 ? '' : route;
}

export function buildRouteUrl(route) {
  return window.location.pathname + '#' + route;
}

export function resolveInitialRoute(appRoot) {
  const hashRoute = normalizeRoute(window.location.hash);
  if (hashRoute) {
    return hashRoute;
  }

  const params = new URLSearchParams(window.location.search);
  const queryRoute = normalizeRoute(params.get('screen') || '');
  if (queryRoute) {
    return queryRoute;
  }

  const initialRoute = normalizeRoute(appRoot.getAttribute('data-initial-route') || '');
  return initialRoute || 'cover';
}
